import { all, call, put, takeLatest } from "redux-saga/effects";
import { httpDelete, httpGet, httpPost } from "../../utils/HttpClient";
import {
  loadIndirectStipsAndDecisionReasonsSuccess,
  LOAD_INDIRECT_STIPS_AND_DECISION_REASONS,
  LoadIndirectStipsAndDecisionReasonsAction,
  CreateDecisionDenialReasonsAction,
  CREATE_DECISION_DENIAL_REASONS,
  DELETE_DECISION_DENIAL_REASON,
  DeleteDecisionDenialReasonAction,
  deleteDecisionDenialReasonSuccess,
  createDecisionDenialReasonsSuccess,
  AssociateDocumentWithStipulationsAction,
  associateDocumentWithStipulationsSuccess,
  ASSOCIATE_DOCUMENT_WITH_STIPULATIONS,
  UpdateIndirectStipulationAction,
  updateIndirectStipulationSuccess,
  UPDATE_INDIRECT_STIPULATION,
  DeleteAppCustomerStipDocumentAssociationAction,
  deleteAppCustomerStipDocumentAssociationSuccess,
  DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION,
} from "./actions";
import { displayError } from "../../utils/utils";
import { authService } from "../..";
import { IndirectDecisionReason, ApplicationStipulation, DecisionCodeDecisionReasonDefault } from "../../Components/IndirectStipsEditor/IndirectStipulation";

function* loadIndirectStipsAndDecisionReasonsSaga(action: LoadIndirectStipsAndDecisionReasonsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpGet,
      `api/ApplicationStipulation/DecisionStipulationsAndReasons/${action.payload.applicationId}`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      const result: { 
        applicationStipulations: ApplicationStipulation[], 
        adverseActionReasons: IndirectDecisionReason[], 
        decisionCodeDecisionReasonDefaults: DecisionCodeDecisionReasonDefault[] 
      } = yield call([response, response.json]);
      yield put(loadIndirectStipsAndDecisionReasonsSuccess(result.applicationStipulations, result.adverseActionReasons, result.decisionCodeDecisionReasonDefaults));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchLoadIndirectStipsAndDecisionReasonsSaga() {
  yield takeLatest(LOAD_INDIRECT_STIPS_AND_DECISION_REASONS, loadIndirectStipsAndDecisionReasonsSaga);
}

function* associateDocumentWithStipulationsSaga(action: AssociateDocumentWithStipulationsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/ApplicationStipulation/AppCustomerStipDocumentAssociations`,
      action.payload.associationInfo,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      yield put(associateDocumentWithStipulationsSuccess(action.payload.associationInfo, action.payload.stipulationCategories));
    }
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchAssociateDocumentWithStipulationsSaga() {
  yield takeLatest(ASSOCIATE_DOCUMENT_WITH_STIPULATIONS, associateDocumentWithStipulationsSaga);
}

function* createDecisionDenialReasonSaga(action: CreateDecisionDenialReasonsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/ApplicationStipulation/DecisionDenialReason`,
      action.payload.createDecisionDenialReasons,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      const newDenialReasons: IndirectDecisionReason[] = yield call([response, response.json]);
      yield put(createDecisionDenialReasonsSuccess(newDenialReasons));
    }
  }
  catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchCreateDecisionDenialReasonSaga() {
  yield takeLatest(CREATE_DECISION_DENIAL_REASONS, createDecisionDenialReasonSaga);
}

function* deleteDecisionDenialReasonSaga(action: DeleteDecisionDenialReasonAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpDelete,
      `api/ApplicationStipulation/DecisionDenialReason/${action.payload.indirectDecisionDenialReasonId}`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      yield put(deleteDecisionDenialReasonSuccess(action.payload.indirectDecisionDenialReasonId));
    }
  }
  catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchDeleteDecisionDenialReasonSaga() {
  yield takeLatest(DELETE_DECISION_DENIAL_REASON, deleteDecisionDenialReasonSaga);
}

function* updateIndirectStipulationSaga(action: UpdateIndirectStipulationAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpPost,
      `api/ApplicationStipulation/updateApplicationStipulationStatus`,
      action.payload,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      yield put(updateIndirectStipulationSuccess(action.payload.applicationStipulationId, action.payload.statusId, action.payload.note));
    }
  }
  catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchUpdateIndirectStipulationSaga() {
  yield takeLatest(UPDATE_INDIRECT_STIPULATION, updateIndirectStipulationSaga);
}

function* deleteAppCustomerStipDocumentAssociationSaga(action: DeleteAppCustomerStipDocumentAssociationAction) {
  try {
    const token: string = yield authService.getToken();
    const response: { json: any, ok: boolean, status: number } = yield call(httpDelete,
      `api/AppCustomerStipulationDocuments/${action.payload.applicationStipulationDocumentId}`,
      token
    );
    if (!response.ok) {
      const error: string = yield call([response, response.json]);
      yield (put(displayError(error)));
    } else {
      yield put(deleteAppCustomerStipDocumentAssociationSuccess(action.payload.applicationStipulationId, action.payload.applicationStipulationDocumentId));
    }
  }
  catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchDeleteAppCustomerStipDocumentAssociationSaga() {
  yield takeLatest(DELETE_APP_CUSTOMER_STIP_DOCUMENT_ASSOCIATION, deleteAppCustomerStipDocumentAssociationSaga);
}


export function* indirectDealerSagas() {
  yield all([
    watchLoadIndirectStipsAndDecisionReasonsSaga(),
    watchAssociateDocumentWithStipulationsSaga(),
    watchCreateDecisionDenialReasonSaga(),
    watchDeleteDecisionDenialReasonSaga(),
    watchUpdateIndirectStipulationSaga(),
    watchDeleteAppCustomerStipDocumentAssociationSaga(),
  ]);
}
